import { defineComponent as t, toRef as n, provide as r, useCssModule as l, openBlock as a, createElementBlock as i, normalizeClass as p, renderSlot as c } from "vue";
import d from "./styles/CdrSkeleton.module.scss.mjs";
import m from "../../../_virtual/_plugin-vue_export-helper.mjs";
const u = t({
  name: "CdrSkeleton",
  props: {
    /**
     * Toggle animation on/off.
     * When `true`, animated gradient will be used while loading.
     * When `false` a static background color will be used.
     * Automatically disabled if `prefers-reduced-motion` is set by user.
     */
    motion: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const o = "cdr-skeleton", s = n(e, "motion");
    return r("motionToggle", s), {
      baseClass: o,
      style: l()
    };
  }
});
function f(e, o, s, _, y, $) {
  return a(), i("div", {
    class: p(e.style[e.baseClass]),
    "aria-live": "polite",
    "aria-busy": "true"
  }, [c(e.$slots, "default")], 2);
}
const C = {
  $style: d
}, g = /* @__PURE__ */ m(u, [["render", f], ["__cssModules", C]]);
export {
  g as default
};
